import React from 'react';
import { connect } from 'react-redux';
import { InventoryTable } from './InventoryTable';
import InstrumentFetcher from './InstrumentFetcher';
import PortfolioFetcher from './PortfolioFetcher';

const InventoryQuote = ({ exchangeSelected, ...props }) => {
  return (
    <InstrumentFetcher
      {...props}
      render={fetchProps => {
        if (exchangeSelected === 'XSTO') {
          return (
            <PortfolioFetcher
              {...props}
              render={({ holding }) => {
                return (
                  <InventoryTable {...fetchProps} holding={holding || 0} />
                );
              }}
            />
          );
        }
        return <InventoryTable {...fetchProps} />;
      }}
    />
  );
};

const mapStateToProps = state => ({
  exchangeSelected: state.exchange.selected,
});

export default connect(mapStateToProps)(InventoryQuote);
